/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { InjectionToken, TemplateRef } from '@angular/core';

export const NGF_TOOLTIP_CONTENT = new InjectionToken<NgfTooltipContent>('Ngf Tooltip Content');

export class TemplateWithContext<C> {
  constructor(public template: TemplateRef<C>,
              public context: C) {}
}

export type NgfTooltipContent = TemplateRef<any> | TemplateWithContext<any> | HTMLElement | string;

export namespace NgfTooltipContent {
  export function isTemplate(content: NgfTooltipContent): content is TemplateRef<any> {
    return content instanceof TemplateRef;
  }

  export function isTemplateWithContext(content: NgfTooltipContent): content is TemplateWithContext<any> {
    return content instanceof TemplateWithContext;
  }

  export function isHTMLElement(content: NgfTooltipContent): content is HTMLElement {
    return content instanceof HTMLElement;
  }

  export function isString(content: NgfTooltipContent): content is string {
    return typeof content === 'string';
  }
}
